import { useSearchParams } from "react-router-dom";
import ProdReportsCard from "./ProdReportsCard";

export default function ProdReportsPage() {
	const [params] = useSearchParams();
	const initialSprintId = params.get("sprintId") ?? undefined;
	const initialProjectIds = params.getAll("projectId");
	const initialUserIds = params.getAll("userId");

	return (
		<div className="mx-auto max-w-[1280px] px-4 py-8 sm:px-6">
			<div className="mb-6">
				<h1 className="text-3xl font-semibold tracking-tight text-foreground">
					Prod Reports
				</h1>
				<p className="mt-1 text-sm text-muted">
					Production report for the selected sprint and filters.
				</p>
			</div>
			<ProdReportsCard
				standalone
				options={{
					initialSprintId,
					initialProjectIds,
					initialUserIds,
					autoApply: true,
				}}
			/>
		</div>
	);
}
